import React from 'react';
import { Link } from 'react-router-dom';

export default function BackLink({ to, children }) {
  return <Link className="back-link" to={to}>&larr; {children}</Link>;
}
